import { AppointmentRescheduleModalContent } from "@features/Appointment/AppointmentRescheduleModal/AppointmentRescheduleModalContent";
import { useAppointmentReschedule } from "@features/Appointment/AppointmentReschedule/useAppointmentReschedule";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { ETimeSlot } from "@modules/eirCustomersFacade/interfaces/models/IAvailableAppointmentDate";
import { IError } from "itsf-ui-common";
import { EInstallationType } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { Modal } from "@common/Modal/Modal";
import { Box, Button, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IParams {
    appointmentId: number;
    appointmentInstallationType: EInstallationType;
    dateValue: string;
    setDateValue(date: string): void;
    timeSlotValue: ETimeSlot;
    setTimeSlotValue(timeSlot: ETimeSlot): void;
    isUpdateAppointmentLoading: boolean;
    updateAppointmentError: IError | undefined;
    isModalOpen: boolean;
    modalTitle: string;
    close(): void;
    updateAppointment(): void;
}

export const AppointmentReschedule = (props: IParams) => {
    const {
        appointmentId,
        dateValue,
        setDateValue,
        timeSlotValue,
        setTimeSlotValue,
        isUpdateAppointmentLoading,
        updateAppointmentError,
        appointmentInstallationType,
        isModalOpen,
        modalTitle,
        close,
        updateAppointment,
    } = props;

    const {
        availableDateList,
        isAvailableDateListLoading,
        availableDateListError,
        isMobile,
    } = useAppointmentReschedule({
        appointmentId,
        isModalOpen,
    });
    const { t } = useTranslation("appointment");
    const error = availableDateListError || updateAppointmentError;
    const isLoading = isAvailableDateListLoading || isUpdateAppointmentLoading;

    return (
        <Modal close={close} hideActions isModalOpen={isModalOpen} title={modalTitle}>
            <HandleErrorAndLoading error={error} hideComponentWrapper isLoading={isLoading}>
                {availableDateList && (
                    <Box paddingY={2}>
                        <AppointmentRescheduleModalContent
                            appointmentInstallationType={appointmentInstallationType}
                            availableAppointmentList={availableDateList}
                            dateValue={dateValue}
                            setDateValue={setDateValue}
                            setTimeSlotValue={setTimeSlotValue}
                            timeSlotValue={timeSlotValue}
                        />
                    </Box>
                )}
                <Stack flexDirection="row" justifyContent="end" marginTop={2}>
                    <Button
                        disabled={isLoading ?? error}
                        fullWidth={isMobile}
                        size="large"
                        variant="contained"
                        onClick={updateAppointment}
                    >
                        {t("rescheduleModalValidationButton")}
                    </Button>
                </Stack>
            </HandleErrorAndLoading>
        </Modal>
    );
};
